import cn from "classnames"

import { Flex } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"

import styles from "./PopoverCard.module.scss"

import type { PopoverCardProps } from "./PopoverCard.types"

export const PopoverCard = <I extends { id: string }>(
  props: PopoverCardProps<I>
) => {
  const {
    aside,
    name,
    description,
    title,
    list,
    subList,
    subTitle,
    Component,
    componentProps = {}
  } = props
  const secondaryText = cn(styles.text, styles.textSecondary)
  const hasSubList = subList && subList.length > 0

  return (
    <InformationPopover.CommonTemplate
      classes={{ title: styles.title, content: styles.content }}
      title={
        <Flex vertical>
          {description && <span className={secondaryText}>{description}</span>}
          <Flex flex={1} gap={30} align="center" justify="space-between">
            <span className={styles.text}>{name}</span>
            {aside && (
              <span className={cn(secondaryText, styles.aside)}>{aside}</span>
            )}
          </Flex>
        </Flex>
      }
    >
      {props.placeholder}
      {!props.placeholder && (
        <Flex vertical gap={8}>
          {title && list.length > 0 && (
            <span className={secondaryText}>{title}</span>
          )}
          {list.map((item) => (
            <Component key={item.id} {...componentProps} {...item} />
          ))}

          {hasSubList && (
            <>
              {subTitle && <span className={secondaryText}>{subTitle}</span>}
              {subList.map((item) => (
                <Component
                  key={item.id}
                  subList
                  {...componentProps}
                  {...item}
                />
              ))}
            </>
          )}
        </Flex>
      )}
    </InformationPopover.CommonTemplate>
  )
}
